import { extendTheme } from "@chakra-ui/react";
import { components } from "./components";

export const theme = extendTheme({
  components,
});
